<script>
	import { tweened } from "svelte/motion";
	import { getContext } from "svelte";
	import { cubicOut } from "svelte/easing";

	const { data, xGet, yGet, y, yDomain } = getContext("LayerCake");

	export let year = 2015;
	export let label;
	export let format = (d) => d;
	export let color = "red";

	$: yearData = $data.find((d) => d.year === year);

	$: pos = [$xGet(yearData), $yGet(yearData)];
	const tPos = tweened([0, 0], { delay: 100, duration: 300, easing: cubicOut });
	$: tPos.set(pos);
</script>

<div
	class="highlight-container"
	style:left="{$tPos[0]}px"
	style:top="{$tPos[1]}px"
	class:flip={$yDomain[0] < 0 && $yDomain[1] === 0}
	class:first={year === 2015}
	class:last={year === 2022}
>
	<div class="label">
		{label || label === "" ? label : format($y(yearData))}
	</div>
	<div class="circle" style:background-color={color} />
</div>

<style lang="scss">
	.highlight-container {
		position: absolute;
		transform: translate(-50%, calc(-100% + 7px));
		text-align: center;
		display: flex;
		flex-direction: column;
		align-items: center;
		column-gap: 3px;

		&.flip {
			transform: translate(-50%, -7px);
			flex-direction: column-reverse;

			&.last {
				flex-direction: row !important;
				transform: translate(calc(-100% + 7px), -50%) !important;
			}
		}
	}

	.label {
		font-size: 12px;
		text-shadow: -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
	}

	.circle {
		width: 14px;
		height: 14px;
		border: 1px solid #fff;
		border-radius: 14px;
		box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.25);
		transition: background-color 0.1s ease-in-out;
	}
</style>
